export default "__VITE_ASSET__CJa7FDHZ__"